function getPostWidth(wrapperWidth, settings) {
  const POST_CARD_SMALL_SIZE = 200
  const POST_CARD_LARGE_SIZE = 300

  if (!settings.hasContainerWidth && settings.slidesToShow) {
    const displayLimit = settings.hasDisplayLimit ? settings.postsToShow : 29
    const visibleSlides = Math.min(settings.slidesToShow, displayLimit)
    return Math.floor(wrapperWidth / visibleSlides)
  }

  return settings.largeCards ? POST_CARD_LARGE_SIZE : POST_CARD_SMALL_SIZE
}

export default getPostWidth
